import { getContext } from 'svelte';
import type { ApiSchemas } from '$lib/api/shopwareApi.js';
import type { SavedCarData } from '$lib/types/SavedCarData.js';

export interface ShopContext {
    storeContext: ApiSchemas['SalesChannelContext'];
    shopwareLanguage: {
        languageId: string;
        shopwareLanguage?: ApiSchemas['Language'];
    };
    savedCarData: SavedCarData;
}

export const SHOP_CONTEXT_KEY = 'SHOP_CONTEXT_KEY';
export const useShopContext = () => getContext<ShopContext>(SHOP_CONTEXT_KEY);

export const useStoreContext = () => useShopContext()?.storeContext;

export const LOCALE_CONTEXT_KEY = 'LOCALE_CONTEXT_KEY';
export const useLocaleContext = () => getContext<string>(LOCALE_CONTEXT_KEY);

export const SAVED_CAR_DATA_STORE_KEY = 'SAVED_CAR_DATA_STORE_KEY';
export const CONTACT_FORM_DATA_STORE_KEY = 'CONTACT_FORM_DATA_STORE_KEY';

export const CUSTOMER_COUPON_CODE_CONTEXT_KEY = 'CUSTOMER_COUPON_CODE_CONTEXT_KEY';
